<template>
  <div class="hero">
    <h3>User Profile</h3>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>